import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import store from '../redux/store';

import DeserventiCalendar from './rsvti/DeserventiCalendarComponent';

import { RefreshWorksiteByEIDCachedData } from './AFStoreDataRefresh';
import * as AFStateHelper from './AFStateHelper';
import * as ReduxDataStatus from '../utils/constants/ReduxDataStatus';
import * as Security from '../utils/auth/Security';


export const DeserventiCalendarPage = () => {
    const reduxStore = store.getState();

    var dataStatus;
    if(Security.isUserOfClientEmployer()) {
        if(reduxStore.clients.status === ReduxDataStatus.SUCCEEDED && 
            reduxStore.worksites.status === ReduxDataStatus.SUCCEEDED) {

            dataStatus = ReduxDataStatus.SUCCEEDED;
        }
        else{
            dataStatus = ReduxDataStatus.LOADING;
        }
    }
    else{
        dataStatus = ReduxDataStatus.SUCCEEDED;
    }

    return (
        <DeserventiCalendar
            loadComponentData={CalenderDataLoader}
            clients={reduxStore.clients.clients}
            worksites={reduxStore.worksites.worksites}
            dataStatus={dataStatus}
        />
    );
}

const CalenderDataLoader = () => {
    const reduxStore = store.getState();

    if(Security.isUserOfClientEmployer()) {
        if(reduxStore.clients.status === ReduxDataStatus.SUCCEEDED) {
            const myEmployerId = AFStateHelper.getSiuClientEmployerEID();

            RefreshWorksiteByEIDCachedData(myEmployerId);
        }
    }
}
